import React from "react";
import { motion } from "motion/react";
import { Instagram, Youtube, Facebook, Music, Mail, Phone, Heart } from "lucide-react";
import { EMAIL, WHATSAPP_NUMBER, WHATSAPP_LINK, socialLinks, menuItems } from "../data/mock";

const iconMap = {
  Instagram: Instagram,
  Youtube: Youtube,
  Facebook: Facebook,
  Music: Music, // TikTok placeholder
};

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <motion.a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="flex items-center gap-2 mb-5"
              whileHover={{ scale: 1.02 }}
            >
              <span className="text-2xl">🌴</span>
              <span className="font-display text-2xl font-semibold">
                Entreterimento<span className="text-[hsl(var(--coral))]">RJ</span>
              </span>
            </motion.a>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Suítes, passeios e experiências inesquecíveis no Rio de Janeiro.
              Seu parceiro de turismo na cidade maravilhosa.
            </p>
            {/* Social Links */}
            <div className="flex gap-3">
              {socialLinks.map((social, index) => {
                const Icon = iconMap[social.icon];
                return (
                  <motion.a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-gray-400 hover:bg-[hsl(var(--coral))] hover:text-white transition-colors"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Icon className="w-5 h-5" />
                  </motion.a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-5">Links Rápidos</h4>
            <ul className="space-y-3">
              {menuItems.map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="text-gray-400 hover:text-[hsl(var(--coral))] transition-colors text-sm"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-5">Serviços</h4>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li>Hospedagem Premium</li>
              <li>Passeios Turísticos</li>
              <li>Eventos & Festas</li>
              <li>Roteiros Gastronômicos</li>
              <li>Transfer & Motorista</li>
              <li>Pacotes Personalizados</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-5">Contato</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`${WHATSAPP_LINK}?text=${encodeURIComponent("Olá! Quero saber mais sobre os pacotes.")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-gray-400 hover:text-[hsl(var(--whatsapp))] transition-colors text-sm"
                >
                  <Phone className="w-5 h-5" />
                  <span>{WHATSAPP_NUMBER}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${EMAIL}`}
                  className="flex items-center gap-3 text-gray-400 hover:text-[hsl(var(--coral))] transition-colors text-sm"
                >
                  <Mail className="w-5 h-5" />
                  <span>{EMAIL}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} Entreterimento RJ. Todos os direitos reservados.
            </p>
            <p className="text-gray-500 text-sm flex items-center gap-1">
              Feito com <Heart className="w-4 h-4 text-[hsl(var(--coral))]" /> no Rio de Janeiro
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
